module.exports = __webpack_public_path__ + "static/home-hero-c4af5e2fe8b6835d7e43b76f2d5d9e7a.png";